import {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";
import {Node as ProseMirrorNode} from "prosemirror-model";
import {NodeViewAdditionalParams} from "./createSetNodeAttributeCommand";


export const deleteNode =
  (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: NodeViewAdditionalParams): boolean => {
    const pos = additionalParams?.getPos?.();
    if (pos === undefined) {
      return false;
    }

    const node: ProseMirrorNode | null = state.doc.nodeAt(pos);
    if (!node) {
      return false;
    }

    // Full size of the node: node itself + its content
    const end = pos + node.nodeSize;

    const tr: Transaction = state.tr.delete(pos, end);
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
